import { ClaimDetails } from './view';

export { default as ClaimDetailsReducer } from './reducer';
export { default as ClaimDetailsSaga } from './saga';

export default ClaimDetails;
